import * as React from 'react'
import { useTranslations } from 'next-intl'

export const Error: React.FC<{ message?: string }> = ({ message }) => {
  const t = useTranslations('forms')
  return (
    <div className={`flex items-center mt-2 text-text-error text-label-XS-regular gap-1`}>
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 11C3.23857 11 1 8.7614 1 6C1 3.23857 3.23857 1 6 1C8.7614 1 11 3.23857 11 6C11 8.7614 8.7614 11 6 11ZM5.5 7.5V8.5H6.5V7.5H5.5ZM5.5 3.5V6.5H6.5V3.5H5.5Z"
          fill="#F6463D"
        />
      </svg>
      {message ?? t('required')}
    </div>
  )
}
